import { FC, useContext, useState } from 'react';
import BasicModal from '../common/BasicModal';
import CreateCampaignModalHeader from './CreateCampaignModalHeader';
import { useTranslation } from 'react-i18next';
import PackagesList from './PackagesList';
import PagesList from './PagesList';
import { CampaignContext } from '../../contexts/CampaignContext';
import ShowPagesModal from './ShowPagesModal.tsx';

type ISelectPagesModal = {
	open: boolean;
	searchTerm: string;
	onClose: () => void;
	onSearch: (term: string) => void;
	handleCreatePageCampaignBySubject: () => void;
	handleCreatePageCampaignByProvince: () => void;
	handleSelectPackages: () => void;
};

const SelectPagesModal: FC<ISelectPagesModal> = ({ open, searchTerm, handleSelectPackages, handleCreatePageCampaignByProvince, handleCreatePageCampaignBySubject, onClose, onSearch }) => {
	const [filterCategory, setFilterCategory] = useState<any | null>(null);
	const { viewSelectedItemsMode, selectedPlatform, selectedMediaTypeId, typeActiveButton, categoryActiveButton, selectedContentType } = useContext(CampaignContext);
	const { t } = useTranslation();

	const [showPages, setShowPages] = useState<number | null>(null);
	const isSMS = selectedPlatform === 'sms';
	const formattedPlatform = isSMS ? 'sms_panel' : selectedPlatform;

	const typeTabs = [
		{
			content: <PackagesList searchTerm={searchTerm} onSave={handleSelectPackages} onCancel={onClose} setShowPages={setShowPages} />,
		},
		{
			content: <></>,
		},
	];

	const categoryTabs = [
		{
			content: <PagesList filterCategory={filterCategory} searchTerm={searchTerm} onSave={handleCreatePageCampaignBySubject} onCancel={onClose} />,
		},
		{
			content: <PagesList filterCategory={filterCategory} searchTerm={searchTerm} onSave={handleCreatePageCampaignByProvince} onCancel={onClose} />,
		},
	];

	const handleCloseDialog = () => {
		if (showPages === null) {
			onClose();
		} else {
			setShowPages(null);
		}
	};

	return (
		<BasicModal
			open={open}
			onClose={handleCloseDialog}
			showBackIcon={false}
			titleKey="create_campaign_modal_title"
			titleValues={{
				adType: t(selectedMediaTypeId as string),
				contentType: t(selectedContentType as string),
				platform: t(formattedPlatform as string),
			}}
		>
			{showPages === null ? (
				<>
					{!viewSelectedItemsMode && <CreateCampaignModalHeader filterCategory={filterCategory} setFilterCategory={setFilterCategory} onSearch={onSearch} searchTerm={searchTerm} />}
					{typeActiveButton === 0 && <div className="mt-4 min-h-full w-full justify-center">{typeTabs[typeActiveButton].content}</div>}
					{typeActiveButton === 1 && <div className="mt-4 min-h-full w-full justify-center">{categoryTabs[categoryActiveButton].content}</div>}
				</>
			) : (
				<ShowPagesModal id={showPages} />
			)}
		</BasicModal>
	);
};

export default SelectPagesModal;
